import { Form, Input, Select } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../../components/DraggableModal";
import { EntCheckpoint } from "../../../../../models/handBooks/checkpoint";
import { MapAddSingleMarker } from "../../../../../components/maps/MapAddPoint";
import { GeoJsonPoint, Geometry } from "../../../../../models/geoJsonPoint";
import modal from "antd/es/modal";

enum FormField {
  nameKy,
  nameRu,
  address,
  type,
  longitude,
  latitude
}

interface IProps {
  show: boolean;
  item: EntCheckpoint;
  onHide: () => void;
  onSubmit: (pos: EntCheckpoint) => Promise<boolean>;
}

export const AddCheckpointModal = (props: IProps) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const { Option } = Select;
  const [loading, setLoading] = useState<boolean>(false);
  const [geoJsonData, setGeoJsonData] = useState<GeoJsonPoint|null>(null);


  useEffect(() => {
	if (props.show) setFieldsFromEntity();
  }, [props.show]);

  const setFieldsFromEntity = (): void => {
	form.setFields([
	  { name: FormField.nameKy, value: props.item.nameKy },
	  { name: FormField.nameRu, value: props.item.nameRu },
	  { name: FormField.address, value: props.item.address },
	  { name: FormField.type, value: props.item.type },
	]);
  }

  const updateGeoJsonPoint = () => {
	const latitude = props.item.latitude;
	const longitude = props.item.longitude;

	if (latitude !== undefined && longitude !== undefined) {
	  const geoJsonPoint = new GeoJsonPoint();
	  geoJsonPoint.geometry = new Geometry();
	  geoJsonPoint.geometry.coordinates = [longitude, latitude];
	  setGeoJsonData(geoJsonPoint);
	} else {
	  console.error(t('breeding_farms.error_geometry'));
	}
  };

  useEffect(() => {
	if (props.item.latitude && props.item.longitude) {
	  updateGeoJsonPoint();
	} else {
	  setGeoJsonData(null);
	}
  }, [props.item.latitude, props.item.longitude]);

  const setEntityFromFields = (): EntCheckpoint => {
	let item = _.cloneDeep(props.item);
	item.nameKy = form.getFieldValue(FormField.nameKy);
	item.nameRu = form.getFieldValue(FormField.nameRu);
	item.address = form.getFieldValue(FormField.address);
	item.type = form.getFieldValue(FormField.type);
	item.longitude = form.getFieldValue(FormField.longitude);
	if (geoJsonData !== null) {
	  item.latitude = geoJsonData.geometry?.coordinates[1] as number;
	  item.longitude = geoJsonData.geometry?.coordinates[0] as number;
	}
	return item;
  };

  const handleSubmit = async () => {
	setLoading(true);
	try {
	  await form.validateFields();
	  if (geoJsonData !== null) {
		const data = setEntityFromFields();
		const result = await props.onSubmit(data);
		if (result) props.onHide();
	  } else {
		modal.error({ title: t('msg.error'), content: t('breeding_farms.choose_location') });
	  }
	} finally {
	  setLoading(false);
	}
  };

  return (
	<>
	  <DraggableModal
		title={ props.item.id === 0 ? t('general.add') : t('general.edit') }
		visible={ props.show }
		onCancel={ props.onHide }
		onSubmit={ handleSubmit }
		submitLoading={ loading }
	  >
		<Form
		  initialValues={ { remember: true } }
		  autoComplete="off"
		  layout="vertical"
		  form={ form }
		>
		  <Form.Item
			label={ t('general.nameKy') }
			name={ FormField.nameKy }
			rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
		  >
			<Input autoComplete="off"/>
		  </Form.Item>
		  <Form.Item
			label={ t('general.nameRu') }
			name={ FormField.nameRu }
			rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
		  >
			<Input autoComplete="off"/>
		  </Form.Item>
		  <Form.Item
			label={ t('Адрес') }
			name={ FormField.address }
			rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
		  >
			<Input autoComplete="off"/>
		  </Form.Item>
		  <Form.Item
			label={ t('Тип') }
			name={ FormField.type }
			rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
		  >
			<Select placeholder={ t('Выберите') }>
			  <Option value="BORDER_PVKP">{ t('Пограничный ветеринарный контрольный пункт') }</Option>
			  <Option value="RAILWAY">{ t('Железнодорожный пункт') }</Option>
			  <Option value="AIRPORT">{ t('Пункт пропуска в аэропорту') }</Option>
			  <Option value="TEMP_STORAGE">{ t('Склад временного хранения') }</Option>
			</Select>
		  </Form.Item>
		</Form>
		<MapAddSingleMarker
		  setGeoJsonData={ setGeoJsonData }
		  geoJsonData={ geoJsonData }
		/>
	  </DraggableModal>

	</>

  )
}
